import React from 'react'
import {
  HeroRoot,
  Container,
} from './ProductDetailHero.styles'
import { Proteins } from 'models/Pet'

type ProductHeroProps = {
    children: JSX.Element[]
    recipe?: Proteins
}

export const ProductDetailHero = ({ children, recipe }: ProductHeroProps) => {

  return (
    <HeroRoot color={recipe || undefined}>
      <Container>
        {children}
      </Container>
    </HeroRoot>
  )
}

ProductDetailHero.displayName = 'RecipeDetailHero'